/** @format */

import React from 'react';
import GridItem from '../../../../components/Grid/GridItem';
import CustomMultiSelect from '../../../../components/Form/CustomMultiSelect';

interface TariffFormProps {
    tariffPlanList: any;
    tariffPlanId: Array<number>;
    handleChangeMultiple: (event: any) => void;
}

const TariffForm = (props: TariffFormProps): React.ReactElement => {
    return (
        <GridItem xs={4}>
            <CustomMultiSelect
                callback={props.handleChangeMultiple}
                value={props.tariffPlanId}
                name={'tariffPlanId'}
                isElementsFromApi={true}
                elements={props.tariffPlanList}
                elementItemValue={'value'}
                elementItemName={'name'}
                label={'pools:sim.service_profile'}
                showSelectAllButton
            />
        </GridItem>
    );
};

export default TariffForm;
